function kat_upravNazvyFiltruProduktu() {
  if (!$("body").hasClass("type-category")) return false;

  $(
    "#category-filter-hover .filter-section.filter-section-parametric > h4 span"
  ).html(function(i, t) {
    return t.replace(/\[([^\]]+)\] /g, "");
  });
} //function  kat_upravNazvyFiltruProduktu()

function kat_zakazKopeniExtrasProduktu() {
  if (!window.location.pathname.includes("/extras/")) return false;

  $(".product .add-to-cart-button").remove();
} //function  kat_zakazKopeniExtrasProduktu()

function kat_readMore() {
  $(".category-perex").ladzoReadMore({
    delic: ".hrReadMore"
  });
} //function  kat_readMore()

export function kat_upravStrankuKategorie() {
  kat_zakazKopeniExtrasProduktu();

  kat_upravNazvyFiltruProduktu();
  kat_readMore();

  document.addEventListener("ShoptetDOMContentLoaded", function() {
    kat_upravNazvyFiltruProduktu();
    kat_readMore();
  });
} //function  kat_upravStrankuKategorie()

/*
$(document).ajaxComplete(function(event, request, settings) {
  kat_upravNazvyFiltruProduktu();
  kat_readMore();

});
*/
